export default __webpack_public_path__ + "static/media/move_to_agree.fccfd7e9.svg";